import { render } from "./staffcard.vue?vue&type=template&id=05b26af4&scoped=true"
import script from "./staffcard.vue?vue&type=script&lang=js"
export * from "./staffcard.vue?vue&type=script&lang=js"

import "./staffcard.vue?vue&type=style&index=0&id=05b26af4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b26af4"],['__file',"src/js/components/staffcard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05b26af4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05b26af4', __exports__)) {
    api.reload('05b26af4', __exports__)
  }
  
  module.hot.accept("./staffcard.vue?vue&type=template&id=05b26af4&scoped=true", () => {
    api.rerender('05b26af4', render)
  })

}


export default __exports__